import React from 'react';
import { observer } from 'mobx-react';
import { Trans } from 'react-i18next';
import { Typography } from 'antd';
import { Link } from 'react-router-dom';
import styles from './DeletedMessagesInfo.module.scss';
const { Text } = Typography;
const DeletedMessagesInfo = ({ count, chatCreatedDate }) => {
    const formatDate = (date) => {
        if (!date)
            return '';
        const dateObj = typeof date === 'string' ? new Date(date) : date;
        if (isNaN(dateObj.getTime()))
            return '';
        return dateObj.toLocaleDateString('en-US', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
        });
    };
    return (React.createElement("div", { className: styles.deletedMessagesWrapper },
        React.createElement("div", { className: styles.deletedMessagesContent },
            React.createElement(Text, { className: styles.deletedMessagesText },
                React.createElement(Trans, { i18nKey: "deletedMessagesInfo", values: { count, date: formatDate(chatCreatedDate) }, components: {
                        bold: React.createElement("strong", null),
                        deleted: React.createElement("span", { className: styles.deletedWord }),
                    } })),
            React.createElement("div", { className: styles.deletedMessagesSubtext },
                React.createElement(Trans, { i18nKey: "deletedMessagesBackupInfo", components: {
                        1: React.createElement(Link, { to: "/manage/chats/auto-delete" })
                    } })))));
};
export default observer(DeletedMessagesInfo);
